import { render, staticRenderFns } from "./SimAppForm.vue?vue&type=template&id=071dfeac&scoped=true&"
import script from "./SimAppForm.vue?vue&type=script&lang=js&"
export * from "./SimAppForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/appstore-simform.css?vue&type=style&index=0&id=071dfeac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071dfeac",
  null
  
)

export default component.exports